import { atom, createStore } from 'jotai'

export interface ActiveCall {
	joinUrl: string
	/** Where the call started — lets the popout's "expand" jump back to the right candidate. */
	companyId: string
	campaignId: string
	candidateId: string
}

/**
 * A dedicated Jotai store for the call state, shared app-wide independent of any route-scoped
 * `<Provider>`. The campaign route wraps its subtree in an anonymous Jotai Provider (its own
 * store), so the candidate card (inside it) and the root-level GlobalCallDock (outside it) would
 * otherwise read/write different stores. Every call-atom hook binds to THIS store explicitly
 * (`{ store: callStore }`) so they always agree.
 */
export const callStore = createStore()

/**
 * The single live Jobilla Meet call, owned app-wide (not by the candidate card) so it keeps
 * running across tab switches, candidate changes, and full page navigations. Rendered by the
 * root-level GlobalCallDock.
 */
export const activeCallAtom = atom<ActiveCall | null>(null)

/**
 * The element the call should dock over — the open Jobilla Meet tab's content area. Set by that
 * tab while it's showing; null the rest of the time, which drops the call to a corner popout.
 */
export const callDockAnchorAtom = atom<HTMLElement | null>(null)
